import SvgIcon from '@mui/material/SvgIcon';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export const _account = [
  { label: 'Home', href: '/', icon: <Iconify icon="solar:home-angle-bold-duotone" /> },
  {
    label: 'Profile',
    href: '#',
    icon: (
      <SvgIcon>
        <path
          opacity="0.5"
          fill="currentColor"
          d="M2.28 19.66a1.9 1.9 0 0 0 1.5 1.72c1.33.28 3.84.62 8.22.62s6.89-.34 8.22-.62a1.9 1.9 0 0 0 1.5-1.72c.13-1.28.28-3.61.28-7.66s-.15-6.38-.28-7.66a1.9 1.9 0 0 0-1.5-1.72C18.9 2.34 16.38 2 12 2s-6.89.34-8.22.62a1.9 1.9 0 0 0-1.5 1.72A78 78 0 0 0 2 12c0 4.05.15 6.38.28 7.66"
        />
        <path
          fill="currentColor"
          d="M13.94 13.86a4.17 4.17 0 1 0-3.88 0 5.8 5.8 0 0 0-3.55 4.2c-.06.26.1.54.36.59.98.17 2.59.35 5.13.35s4.16-.18 5.13-.35c.27-.05.42-.33.36-.6a5.8 5.8 0 0 0-3.55-4.2"
        />
      </SvgIcon>
    ),
  },
  {
    label: 'Projects',
    href: '#',
    icon: <Iconify icon="solar:notes-bold-duotone" />,
    info: '3',
  },
  {
    label: 'Subscription',
    href: '#',
    icon: (
      <SvgIcon>
        <path
          opacity="0.5"
          fill="currentColor"
          d="M17.756 2.3c-.404-.186-.639-.21-.693-.214A130 130 0 0 0 12 2c-4.275 0-6.693.143-8.02.276-.939.094-1.61.765-1.704 1.705C2.143 5.307 2 7.725 2 12c0 4.645.169 7.604.31 9.27.065.769.936 1.108 1.53.613L5.5 20.5l1.367 1.367a1 1 0 0 0 1.332.074l1.8-1.441 1.293 1.293a1 1 0 0 0 1.414 0L14 20.5l1.801 1.44a1 1 0 0 0 1.332-.073L18.5 20.5l1.66 1.383c.594.495 1.465.156 1.53-.614.142-1.665.31-4.624.31-9.269 0-2.127-.035-3.795-.087-5.097C21.474 6.957 20.856 7 20 7c-.63 0-1.13-.023-1.525-.057-.86-.073-1.42-.731-1.452-1.594A35 35 0 0 1 17 4c0-.886.024-1.5.052-1.914 0 0 .24 0 .704.215m-6.097 12.967q.816 0 1.18-.276.377-.276.377-.676a.7.7 0 0 0-.287-.58q-.288-.22-.862-.386l-.832-.249q-.62-.18-1.118-.386a3.3 3.3 0 0 1-.847-.497 2.1 2.1 0 0 1-.544-.69 2.14 2.14 0 0 1-.197-.952q0-.939.635-1.56t1.815-.828v-.393c0-.408.282-.773.69-.79Q11.75 7 11.825 7q.56 0 .802.18.255.18.256.648v.304q.969.096 1.573.428.605.317.605.841c0 .156-.042.3-.113.431-.19.348-.663.323-1.038.196a5 5 0 0 0-.346-.102 4.5 4.5 0 0 0-1.255-.166q-.756 0-1.134.235-.363.22-.363.58 0 .29.242.469.257.18.771.331l.847.235q1.36.386 2.086 1.021.741.635.741 1.711 0 .953-.665 1.615-.666.65-1.95.87v.379c0 .408-.283.773-.691.79l-.156.004q-.56 0-.817-.18-.241-.18-.242-.648v-.276q-1.103-.111-1.799-.483-.68-.387-.68-.966c0-.226.087-.422.226-.587.249-.295.692-.222 1.034-.044q.22.112.479.217.62.234 1.42.234"
        />
        <path
          fill="currentColor"
          d="M21.913 6.903C21.475 6.957 20.857 7 20 7c-.63 0-1.13-.023-1.525-.057-.86-.073-1.42-.731-1.452-1.594A35 35 0 0 1 17 4c0-.886.024-1.5.052-1.914 0 0 1.035.002 2.948 1.914 1.913 1.913 1.913 2.903 1.913 2.903M11.66 15.267q.816 0 1.18-.276.377-.276.377-.676a.7.7 0 0 0-.287-.58q-.288-.22-.862-.386l-.832-.249q-.62-.18-1.118-.386a3.3 3.3 0 0 1-.847-.497 2.1 2.1 0 0 1-.544-.69 2.14 2.14 0 0 1-.197-.952q0-.939.635-1.56t1.815-.828v-.393c0-.408.282-.773.69-.79Q11.75 7 11.826 7q.56 0 .801.18.258.18.257.648v.304q.969.096 1.573.428.605.317.605.841c0 .156-.042.3-.113.431-.19.348-.663.323-1.038.196a5 5 0 0 0-.346-.102 4.5 4.5 0 0 0-1.255-.166q-.756 0-1.134.235-.363.22-.363.58 0 .29.242.469.256.18.771.331l.847.235q1.36.386 2.086 1.021.741.635.741 1.711 0 .953-.665 1.615-.666.65-1.95.87v.379c0 .408-.283.773-.691.79l-.156.004q-.56 0-.817-.18-.241-.18-.242-.648v-.276q-1.103-.111-1.799-.483-.68-.387-.68-.966c0-.226.087-.422.226-.587.248-.295.692-.222 1.034-.044q.22.112.479.217.62.234 1.42.234"
        />
      </SvgIcon>
    ),
  },
  { label: 'Security', href: '#', icon: <Iconify icon="solar:shield-keyhole-bold-duotone" /> },
  { label: 'Account settings', href: '#', icon: <Iconify icon="solar:settings-bold-duotone" /> },
];
